// extracted by mini-css-extract-plugin
export default {"background":"HorizontalSlider_background__F+HTj","handle":"HorizontalSlider_handle__EMJXk"};